import { MESFMain } from "@dexteel/mesf-core";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "react-dom";
import "./app.css";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			cacheTime: 1000 * 60,
		},
	},
});
render(
	<QueryClientProvider client={queryClient}>
		<MESFMain
			showAreaSelector={true}
			showTrendingsIcon={false}
			showTrendingsV2Icon={true}
			routes={CustomRoutes}
			navbarTitle={"RBD MILL"}
			navbar={CustomNavbar}
			authentication={AuthenticationConfig}
			configurations={customConfigurations}
			logbookSettings={{
				entry: {
					allowAttachments: true,
					canEditShift: true,
					showShiftCrew: true,
					exportToExcel: true,
				},
				report: {
					showAttachments: true,
					showShiftCrew: true,
					exportToExcel: true,
				},
			}}
		/>
	</QueryClientProvider>,
	document.getElementById("root"),
);
